import { useDispatch, useSelector } from 'react-redux'
import { Link } from 'react-router-dom'
import EventEmitter, {
  SHOW_POPUP_FOLLOW_ALERT,
  SHOW_POPUP_MANAGE_COMPANY_PORTFOLIO,
} from '../../../helpers/EventEmitter'
import { COMPONENTS } from '../../../routers/constants'
import { Z_INDEX } from '../../../utils/common'
import useViewport from '../../hooks/useViewport'
import { TextLink } from '../../html/TextLink'
import { Element } from '../../html/element'
import { Switch } from '../../html/switch'
import { Panel } from '../../panel'
import { Table } from '../../table'
import { TextEllipsisStaticLine } from '../../textEllipsis/TextEllipsisStaticLine'
import { ALERT_STATUS_ID } from './constant'
import classes from './index.module.scss'
import { changeSettings, selectSettings } from './store/slice'

export const PortfolioList = () => {
  const dispatch = useDispatch()
  const { height } = useViewport()
  const portfolios = useSelector(selectSettings('portfolios')) || []

  const ids = portfolios.map((_, index) => index)

  const onChange = (isCheck, rowIndex) => {
    const newPortfolios = JSON.parse(JSON.stringify(portfolios))
    newPortfolios[rowIndex].alertStatusId = isCheck
      ? ALERT_STATUS_ID.ON
      : ALERT_STATUS_ID.OFF
    dispatch(changeSettings({ portfolios: newPortfolios }))
  }

  const openManagePortfolios = () => {
    EventEmitter.dispatch(SHOW_POPUP_FOLLOW_ALERT, false)
    EventEmitter.dispatch(SHOW_POPUP_MANAGE_COMPANY_PORTFOLIO, true)
  }

  return (
    <div className={classes.portfolioList}>
      <Panel
        label="common.popup.followAlert.PORTFOLIO_LIST"
        isI18n
        height={height * 0.35}
      >
        {!portfolios.length ? (
          <div
            className="wh100 dFlex textCenter alignItemsCenter justifyContentCenter fstItalic"
            style={{ color: '#9C9C9C' }}
          >
            <TextLink
              id="NO_PORTFOLIO_LIST_LINK"
              value="common.popup.followAlert.NO_PORTFOLIOS"
              labelLink="common.popup.followAlert.CLICK_HERE_FIRST_UPPERCASE"
              onClick={openManagePortfolios}
              isTextDecoration={false}
            />
          </div>
        ) : (
          <Table
            ids={ids}
            schema={[
              {
                colId: 'Switch',
                title: '',
                isI18n: true,
                tdStyle: { width: 40 },
                render: (_, { rowIndex }) => {
                  return (
                    <Switch
                      checked={
                        portfolios[rowIndex].alertStatusId ===
                        ALERT_STATUS_ID.ON
                      }
                      onChange={(isCheck) => onChange(isCheck, rowIndex)}
                    />
                  )
                },
              },
              {
                colId: 'PortfolioName',
                title: 'common.popup.followAlert.PORTFOLIO_NAME',
                isI18n: true,
                tdStyle: { width: '50%' },
                render: (_, { rowIndex }) => {
                  const data = portfolios[rowIndex]
                  return (
                    <Element style={{ color: '#2C73E8' }}>
                      <Link
                        to={`${COMPONENTS.library.components.savedPortfolios.components.detailsPortfolio.route}?id=${data.portfolioId}`}
                        target="_blank"
                      >
                        <TextEllipsisStaticLine
                          text={data.portfolioName}
                          isI18n={false}
                          lineClamp={1}
                          zIndexTooltip={Z_INDEX.MODAL + 1}
                        />
                      </Link>
                    </Element>
                  )
                },
              },
              {
                colId: 'ProfileName',
                title: 'common.popup.followAlert.PROFILE_NAME',
                isI18n: true,
                tdStyle: { width: '50%' },
                render: (_, { rowIndex }) => {
                  const data = portfolios[rowIndex]
                  return (
                    <Element style={{ color: '#2C73E8' }}>
                      <Link
                        to={`${COMPONENTS.alerts.components.alertSetting.route}?profileId=${data.alertProfileId}`}
                        target="_blank"
                      >
                        <TextEllipsisStaticLine
                          text={data.profileAlertsName}
                          isI18n={false}
                          lineClamp={1}
                          zIndexTooltip={Z_INDEX.MODAL + 1}
                        />
                      </Link>
                    </Element>
                  )
                },
              },
            ]}
          />
        )}
      </Panel>
    </div>
  )
}
